import * as React from "react";
import create from "zustand";
import createContext from "zustand/context";

type SelectedNavigatorFile = {
  fileId: string;
  fileName: string;
  fileVersionId: string;
};

type FilesFoldersNavigatorState = {
  folderId: string;
  folderName: string;
  initialFolderId: string;
  projectId: string;
  navigate: (folderId: string) => void;
  selectFile: (file: SelectedNavigatorFile) => Promise<void>;
  setFolderName: (folderName: string) => void;
};

const { Provider, useStore: useFileFoldersNavigatorContext } =
  createContext<FilesFoldersNavigatorState>();

type FilesFoldersNavigatorModesProviderProps = {
  initialFolderId: string;
  projectId: string;
  children: React.ReactNode;
  onFolderChange?: (folderId: string) => unknown;
  onFileSelect?: (file: SelectedNavigatorFile) => unknown;
};

function FilesFoldersNavigatorProvider(
  props: FilesFoldersNavigatorModesProviderProps
) {
  const { children, initialFolderId, onFileSelect, onFolderChange, projectId } =
    props;
  const store = React.useMemo(
    () =>
      create<FilesFoldersNavigatorState>((set) => ({
        folderId: initialFolderId,
        folderName: "",
        initialFolderId,
        navigate: (folderId: string) => {
          set({ folderId });
          onFolderChange?.(folderId);
        },
        projectId,
        selectFile: async (file: SelectedNavigatorFile) => {
          await onFileSelect?.(file);
        },
        setFolderName: (folderName: string) => set({ folderName }),
      })),
    [initialFolderId, onFileSelect, onFolderChange, projectId]
  );

  return <Provider createStore={() => store}>{children}</Provider>;
}

export type { FilesFoldersNavigatorModesProviderProps };
export type { SelectedNavigatorFile };
export { FilesFoldersNavigatorProvider, useFileFoldersNavigatorContext };
